// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-fbltd";
var _4 = "tabs__tab-2V8ZY";
var _5 = "tabs__selectedTab-1a4bE";
var _6 = "tabs__tab__label-3mEy4";
var _7 = "tabs__tab__header-1BQP4";
var _8 = "stickyTabs-pdkOE";
var _9 = "tabs__container-11sDh";
var _a = "flexTabsContainer-z5_RF";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "tabs__tab", _5 as "tabs__selectedTab", _6 as "tabs__tab__label", _7 as "tabs__tab__header", _8 as "stickyTabs", _9 as "tabs__container", _a as "flexTabsContainer" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "tabs__tab": _4, "tabs__selectedTab": _5, "tabs__tab__label": _6, "tabs__tab__header": _7, "stickyTabs": _8, "tabs__container": _9, "flexTabsContainer": _a }
